import { createSlice } from "@reduxjs/toolkit";
import { BROWSE_TRIPOD } from "./constant";

export const tripodSlice = createSlice({
  name: BROWSE_TRIPOD,
  initialState: {
    listTripod: {
      filterData: {
        stations: [],
        statuses: {},
        device_models: []
      },
      tripodsInfo: {
        data: [],
        total: 0,
        online: 0
      }
    },
    tripodLog: {
      filterData: {
        device_ids: [],
        device_ips: [],
        verify_modes: {},
        checkin_types: {},
        sync_states: {},
        stations: []
      },
      tripodList: {
        data: [],
        total: 0
      }
    },
    tripodDailyLog: {
      filterData: {
        departments: [],
        stations: []
      },
      tripodDailyLogs: {
        data: [],
        total: 0
      }
    }
  },
  reducers: {
    getTripodFilterDataSucceed(state, action) {
      state.listTripod.filterData = action.payload;
      return state;
    },
    getTripodFilterDataFailed(state) {
      state.listTripod.filterData = {
        stations: [],
        statuses: {},
        device_models: []
      };
      return state;
    },
    getListTripodSucceed(state, action) {
      state.listTripod.tripodsInfo = action.payload.data;
      return state;
    },
    getListTripodFailed(state) {
      state.listTripod.tripodsInfo = {
        data: [],
        total: 0,
        online: 0
      };
      return state;
    },
    //  tripod log
    getTripodLogFilterDataSucceed(state, action) {
      state.tripodLog.filterData = action.payload;
      return state;
    },
    getTripodLogFilterDataFailed(state) {
      state.tripodLog.filterData = {
        device_ids: [],
        device_ips: [],
        verify_modes: {},
        checkin_types: {},
        sync_states: {},
        stations: []
      };
      return state;
    },
    getTripodLogListDataSucceed(state, action) {
      state.tripodLog.tripodList = action.payload;
      return state;
    },
    getTripodLogListDataFailed(state) {
      state.tripodLog.tripodList = {
        data: [],
        total: 0
      };
      return state;
    },
    //  tripod daily log
    getTripodDailyLogFilterDataSucceed(state, action) {
      state.tripodDailyLog.filterData = action.payload;
      return state;
    },
    getTripodDailyLogFilterDataFailed(state) {
      state.tripodDailyLog.filterData = {
        departments: [],
        stations: []
      };
      return state;
    },
    getTripodDailyLogListDataSucceed(state, action) {
      state.tripodDailyLog.tripodDailyLogs = action.payload;
      return state;
    },
    getTripodDailyLogListDataFailed(state) {
      state.tripodDailyLog.tripodDailyLogs = {
        data: [],
        total: 0
      };
      return state;
    }
  }
});

export const tripodActions = tripodSlice.actions;
export const tripodReducers = tripodSlice.reducer;
